module.exports = __webpack_public_path__ + "common/icon-full-color-52b7595bc0d55fffb308cfe79761beb8.svg";